import { ApprDecisionDialog } from '@/common/appr/ApprDecisionDialog';
import { ApprRouteProgressDialog } from '@/common/appr/ApprRouteProgressDialog';
import { Banner } from '@/common/banner/Banner';
import { useKrCardContext } from '@/common/card/KrCardContext';
import { useDialog } from '@/common/dialog/DialogContext';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTab } from '../entityTabs/TabContext';
import { useEntityMgr } from '../entityView/EntityMgrContext';

/**
 * TODO: Explore posibility of the Banner solely being driven by active Jobs and not statuses on the entityObj
 */
export const EntityBanner = () => {
  const { entityDef, entityObj, jobs, hist, asOfDate } = useEntityMgr();
  const { principal } = usePrincipal();
  const { openDialog } = useDialog();
  const inDialog = useInDialog();
  const inKrCard = Boolean(useKrCardContext());
  const { tabId } = useTab();

  const rsrc = useRsrc();
  const entity = useEntityFromRoute();

  const [apprEvent, setApprEvent] = useState();

  const shouldDisplay = !(inDialog || inKrCard || tabId);

  useEffect(() => {
    if (!shouldDisplay || Object.keys(entityObj).length === 0) return;
    const rowsReq = {
      replaceParams: {
        username: principal.username,
      },
      expr: ExprUtils.whereParams('entity', entity, 'entityId', entityObj.id),
    };

    rsrc.rows('skdr', 'APPR_EVENTS', rowsReq).then((apprEvent) => {
      setApprEvent(apprEvent[0]);
    });
  }, [shouldDisplay, entityObj?.id]);

  const openApprDecisionDialog = () => {
    const data = { runIds: [apprEvent.runId], title: 'Approving ' + entityDef.displayName };
    openDialog(ApprDecisionDialog, { data }).then((res) => {
      if (res?.type) {
        setApprEvent(null);
      }
    });
  };

  const openApprRouteProgressDialog = () => {
    const data = { apprJobId: entityObj.apprJobId };
    openDialog(ApprRouteProgressDialog, { data });
  };

  if (!shouldDisplay) return;

  return (
    <>
      {/* Approval Routes */}
      {!(hist || asOfDate) && entityObj.status === 'APPROVING' && (
        <Banner icon={fas.faExclamationTriangle} text={`Item is pending ${apprEvent ? 'your ' : ''}approval`}>
          <Button color="inherit" onClick={() => openApprRouteProgressDialog()}>
            View Approval Route
          </Button>
          {apprEvent && (
            <Button color="inherit" onClick={() => openApprDecisionDialog()}>
              Approve or Reject
            </Button>
          )}
        </Banner>
      )}

      {/* Validation Errors */}
      {!(hist || asOfDate) &&
        entityObj.status === 'DRAFT' &&
        entityObj.valStatus === 'ERROR' &&
        !jobs.some((job) => job.cat === 'VAL') && (
          <Banner
            icon={fas.faExclamationTriangle}
            text="Errors were found while validating. Please review the Validations Tab"
            severity="warning"
          />
        )}

      {/* Active Jobs */}
      {jobs.map((job) => (
        <Banner
          key={job.id}
          icon={fas.faExclamationTriangle}
          text={'Running ' + (job.cat === 'EXPORT' ? 'Export ' : '') + job.name}
        />
      ))}
    </>
  );
};
